import { useState, useEffect } from "react";

const COLLAPSE_SCROLL_THRESHOLD = 50;
const EXPAND_SCROLL_THRESHOLD = 10;

export default function useScrolled() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled((current) => (
        window.scrollY > (current ? EXPAND_SCROLL_THRESHOLD : COLLAPSE_SCROLL_THRESHOLD)
      ));
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return isScrolled;
}
